const EmptyTestimonial = () => {
    return <div>EmptyTestimonial</div>;
};
  
EmptyTestimonial.displayName = "EmptyTestimonial";
export { EmptyTestimonial };
  